import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { datadogLogs } from "@datadog/browser-logs";
import { env } from "./env";

if (["prod"].includes(env.DATADOG_ENV)){
  datadogRum.init({
    applicationId: env.DATADOG_APPLICATION_ID,
    clientToken: env.DATADOG_CLIENT_TOKEN,
    site: env.DATADOG_SITE,
    service: env.DATADOG_SERVICE,
    env: env.DATADOG_ENV,

    // Specify a version number to identify the deployed version of your application in Datadog
    version: env.APP_VERSION || '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: false })],
  });

  datadogLogs.init({
    clientToken: env.DATADOG_CLIENT_TOKEN,
    site: env.DATADOG_SITE,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    env: env.DATADOG_ENV,
    service:env.DATADOG_SERVICE,
  });
}
